<template>
  <div class="contact-wrap">
    <!-- page header -->
    <div class="contact-title">
      <h3>{{t.contact.title}}</h3>
    </div>
    <p>{{t.contact.text}}}</p>
    <div class="contact-form">
      <div class="input-group">
        <!-- Full name -->
        <label for="name">{{t.contact.fullname }}</label>
        <input v-model="data.Key" id="name" type="text">
      </div>
      <div class="input-group">
        <!-- Email -->
        <label for="email">{{t.contact.email }}</label>
        <input v-model="data.Email" id="email" type="text">
      </div>
      <div class="input-group">
        <!-- Subject -->
        <label for="subject">{{t.contact.subject }}</label>
        <input v-model="data.Subject" id="subject" type="text">
      </div>
      <div class="input-group">
        <!-- Message -->
        <label for="message">{{t.contact.message }}</label>
        <textarea v-model="data.Message" id="message" rows="8"></textarea>
      </div>
      <!-- submit -->
      <div class="input-group">
        <div style="padding:10px 0">
          <!-- recaptcha -->
          <vue-recaptcha
            class="g-recaptcha"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="compatch"
            :sitekey="captchaKey"
          ></vue-recaptcha>
        </div>
        <!-- recaptcha return submit button-->
        <button @click="formPost">
          <span v-if="!sending">{{t.contact.send }}</span>
          <span v-if="sending">
            <i class="diginity dg-loading diginity-is-spinning"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      data: {
        Key: "",
        Email: "",
        Subject: "",
        Message: ""
      },
      captcha: false,
      captchaKey: re__captcha,
      sending: false
    };
  },
  computed: {
    // get translate object
    ...mapGetters(["t"])
  },
  methods: {
    onExpired: function() {
      this.resetRecaptcha();
    },
    onVerify: function(response) {
      this.captcha = true;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    async formPost() {
      // email pattern for regexp
      const emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        !this.data.Key.length ||
        !this.data.Email.length ||
        !this.data.Subject.length ||
        !this.data.Message.length
      ) {
        return alert(this.t.contact.error);
      }

      // captcha error
      if (!this.captcha) {
        return alert(this.t.contact.errorCaptcha);
      }

      // loading spinner
      this.sending = true;
      // store 'store_modules/Acritons.js' see => send_form (this function returned)
      const request = await this.$store.dispatch("send_form", this.data);
      this.sending = false;
      // request hasError false
      if (!request) {
        this.data.Key = "";
        this.data.Email = "";
        this.data.Subject = "";
        this.data.Message = "";
        return alert(this.t.contact.sendSuccess);
        // request Error
      } else {
        return alert(this.t.contact.sendError);
      }
    }
  },
  components: { VueRecaptcha }
};
</script>

<style lang="scss" scoped>
.contact-wrap {
  color: #555;
  padding: 20px;
  .contact-title {
    padding: 10px;
    font-size: 16px;
    max-width: 700px;
    margin: 0 auto;
  }
  p {
    max-width: 700px;
    margin: 0 auto;
    padding: 20px 0;
    font-size: 12px;
    line-height: 20px;
  }
  .contact-form {
    padding: 10px 0;
    max-width: 500px;
    margin: 0 auto;
    .input-group {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      button {
        margin-top: 10px;
        font-size: 18px;
        background: #868789;
        border: 1px solid #474849;
        padding: 10px;
        outline: none;
        color: #fff;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          background: #007095;
          border: 1px solid #00536f;
        }
      }
      label {
        font-size: 14px;
        padding: 5px;
      }
      input,
      textarea {
        padding: 10px;
        color: #555;
        font-size: 15px;
      }
      textarea {
        border: 1px solid #ccc;
        resize: vertical;
        outline: none;
      }
    }
  }
}
</style>
